  <mat-table class="products-table"
             #table [dataSource]="subscribers()"
             matSort
             fusePerfectScrollbar>
    <!-- Name Column -->
    <ng-container cdkColumnDef="country">
      <mat-header-cell *cdkHeaderCellDef mat-sort-header>{{ 'canton.country' | translate }}</mat-header-cell>
      <mat-cell *cdkCellDef="let subscriber">
        <img style="height: 40px" [src]="'assets/images/' + subscriber?.country?.flag + '.svg'"/>
      </mat-cell>
    </ng-container>
    <ng-container cdkColumnDef="canton">
      <mat-header-cell *cdkHeaderCellDef mat-sort-header>{{ 'main.canton' | translate }}</mat-header-cell>
      <mat-cell *cdkCellDef="let subscriber">
        <p class="text-truncate">{{ subscriber?.city?.name }}</p>
      </mat-cell>
    </ng-container>
    <ng-container cdkColumnDef="organization">
      <mat-header-cell *cdkHeaderCellDef mat-sort-header>{{ 'main.organization' | translate }}</mat-header-cell>
      <mat-cell *cdkCellDef="let subscriber">
        <p class="text-truncate">{{ subscriber?.organization?.name }}</p>
      </mat-cell>
    </ng-container>
    <ng-container cdkColumnDef="reserve">
      <mat-header-cell *cdkHeaderCellDef mat-sort-header>{{ 'event.placesForOrganizations' | translate }}
      </mat-header-cell>
      <mat-cell *cdkCellDef="let subscriber">
        @if (!subscriber.editPlaces) {
          <p class="text-truncate w100">{{ subscriber?.numberOfSeats }}</p>
          <mat-icon class="edit-places" (click)="subscriber.editPlaces = !subscriber.editPlaces">edit</mat-icon>
        } @else {
          <input class="w100 edit-place-input" type="number" min="0"
                 [value]="subscriber?.numberOfSeats"
                 placeholder="{{'event.places' | translate}}"
                 (input)="subscriber.numberOfSeats = $any($event.target).value">
          <mat-icon class="edit-places"
                    (click)="saveNumberOfPlaces(subscriber);">
            save
          </mat-icon>
        }
      </mat-cell>
    </ng-container>
    <ng-container cdkColumnDef="participants">
      <mat-header-cell *cdkHeaderCellDef mat-sort-header>
        {{ 'event.participants' | translate }}
        <mat-icon [matTooltip]="'event.subscribedToEventInfo' | translate">info</mat-icon>
      </mat-header-cell>
      <mat-cell *cdkCellDef="let subscriber">
        <p class="text-truncate">{{ subscriber?.participant }}
          @if (subscriber?.waitingList) {
            <span>({{ subscriber?.waitingList }})</span>
          }
        </p>
      </mat-cell>
    </ng-container>
    <mat-header-row *cdkHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
    <mat-row *cdkRowDef="let subscriber; columns: displayedColumns;"
             class="product"
             matRipple>
    </mat-row>
  </mat-table>
  @if (subscribers().length === 0) {
    <div class="no-data-msg">
      <span class="mat-headline-6">{{ 'main.noData' | translate }}</span>
    </div>
  }
  <mat-paginator #paginator
                 [length]="subscribers().length"
                 [pageIndex]="0"
                 [pageSize]="50"
                 [pageSizeOptions]="[25, 50, 100]">
  </mat-paginator>
